export enum Currency {
  BGN = 0,
  EUR = 1,
}
